import { Select, styled } from "@mui/material";
import { useMemo } from "react";
import { BaseMetadataType } from "../../Core/Api/Types/base-metadata-type";
import { DbMetadataFieldInfos } from "../../Core/Api/Types/db-metadata-field-infos";
import NewRequestInputBool from "./MetadataInputTypes/new-request-input-bool";
import NewRequestInputCasts from "./MetadataInputTypes/new-request-input-casts";
import NewRequestInputDate from "./MetadataInputTypes/new-request-input-date";
import NewRequestInputLangSingle from "./MetadataInputTypes/new-request-input-lang-single";
import NewRequestInputLangMulti from "./MetadataInputTypes/new-request-lang-multi";
import NewRequestInputStringMulti from "./MetadataInputTypes/new-request-string-multi";
import NewRequestInputStringOrNumberSingle from "./MetadataInputTypes/new-request-string-single";
import NewRequestInputSynopses from "./MetadataInputTypes/new-request-synopses";
import NewRequestInputTerritory from "./MetadataInputTypes/new-request-territory";
import NewRequestInputTitles from "./MetadataInputTypes/new-request-titles";

export interface NewRequestMetadataInputProps {
  metadata: DbMetadataFieldInfos;
  value: any;
  isErrored: boolean;
  onChange: (value: any) => void;
}

const NewRequestMetadataInput = (props: NewRequestMetadataInputProps) => {
  const { metadata, value, isErrored, onChange } = props;

  const _component = useMemo(
    () => (
      <>
        {(metadata.baseType === BaseMetadataType.DbLanguageCodeMetadataValueInfos ||
          metadata.baseType === BaseMetadataType.DbLocalizedLanguageCodeMetadataValueInfos) && (
          <NewRequestInputLangSingle onChange={onChange} metadata={metadata} value={value} isErrored={isErrored} />
        )}
        {(metadata.baseType === BaseMetadataType.DbStringMetadataValueInfos ||
          metadata.baseType === BaseMetadataType.DbLongMetadataValueInfos ||
          metadata.baseType === BaseMetadataType.DbDoubleMetadataValueInfos) && (
          <NewRequestInputStringOrNumberSingle
            onChange={onChange}
            metadata={metadata}
            value={value}
            isErrored={isErrored}
          />
        )}
        {metadata.baseType === BaseMetadataType.DbLanguageCodeMultiMetadataValueInfos && (
          <NewRequestInputLangMulti onChange={onChange} metadata={metadata} value={value} isErrored={isErrored} />
        )}
        {(metadata.baseType === BaseMetadataType.DbStringMultiMetadataValueInfos ||
          metadata.baseType === BaseMetadataType.DbLongMultiMetadataValueInfos ||
          metadata.baseType === BaseMetadataType.DbDoubleMultiMetadataValueInfos) && (
          <NewRequestInputStringMulti onChange={onChange} metadata={metadata} value={value} isErrored={isErrored} />
        )}
        {metadata.baseType === BaseMetadataType.DbDateTimeMetadataValueInfos && (
          <NewRequestInputDate onChange={onChange} metadata={metadata} value={value} isErrored={isErrored} />
        )}
        {metadata.baseType === BaseMetadataType.DbBoolMetadataValueInfos && (
          <NewRequestInputBool onChange={onChange} metadata={metadata} value={value} isErrored={isErrored} />
        )}
        {metadata.baseType === BaseMetadataType.DbCastsMetadataValueInfos && (
          <NewRequestInputCasts onChange={onChange} metadata={metadata} value={value} isErrored={isErrored} />
        )}
        {metadata.baseType === BaseMetadataType.DbSynopsesMetadataValueInfos && (
          <NewRequestInputSynopses onChange={onChange} metadata={metadata} value={value} isErrored={isErrored} />
        )}
        {metadata.baseType === BaseMetadataType.DbTerritoryCodeMetadataValueInfos && (
          <NewRequestInputTerritory onChange={onChange} metadata={metadata} value={value} isErrored={isErrored} />
        )}
        {metadata.baseType === BaseMetadataType.DbTitlesMetadataValueInfos && (
          <NewRequestInputTitles onChange={onChange} metadata={metadata} value={value} isErrored={isErrored} />
        )}
      </>
    ),
    [metadata, value, onChange]
  );
  return <>{_component}</>;
};

export default NewRequestMetadataInput;

export const NewRequestSelect = styled(Select)(({ theme }) => ({
  maxWidth: "100%",
  minWidth: 0,
  flex: 1,
  ".MuiSelect-select": {
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    ...theme.typography.body2,
  },
  "&.Mui-error": {
    ".MuiSelect-select": {
      color: theme.palette.text.secondary,
    },
  },
}));
